import styled from 'styled-components';

const Tooltip = styled.div`
    box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.02), 0px 4px 4px rgba(0, 0, 0, 0.06);
    border-radius: 20px;    
    min-height: 20px;
    position: absolute;
    right: 0px;
    top: 40px;
    background: #FFFFFF;
    border: 1px #D8DCE1 solid;
    z-index: 1;
`

export default Tooltip;